const keys = {
  driverLicenceDetails: {
    yearHelper_self: 'You got this licence in {{fromYear}}-{{toYear}}',
    yearHelper_other: '{{firstName}} got their licence in {{fromYear}}-{{toYear}}',
    agePlaceholder: 'Ex. 18',
    firstLicence: {
      fieldLabel: 'What licence class was it?',
      helper:
        "Not sure? Most drivers start with a G1 (a beginner's permit with restrictions), then move to a G2, and eventually a full G licence.\nThink back to your earliest licence — did you have to drive with someone else in the car or avoid highways? That was likely your G1.",
    },
    g2Licence: {
      fieldLabel_self: 'Did you get a G2?',
      fieldLabel_other: 'Did they get a G2?',
      helper:
        'G2 comes after G1 — it lets you drive alone, but still has some restrictions, like passenger limits or late-night rules if you were under 20.',
      ageLabel_self: 'How old were you when you got your G2 licence?',
      ageLabel_other: 'How old were they when they got their G2 licence?',
      ageHelper: 'A lot of people get their G2 about 8 to 12 months after their G1.',
    },
    gLicence: {
      fieldLabel_self: 'Did you get a G?',
      fieldLabel_other: 'Did they get a G?',
      helper: 'The G licence is the final step — no restrictions, full driving privileges.',
      ageLabel_self: 'How old were you when you got your G licence?',
      ageLabel_other: 'How old were they when they got their G licence?',
      ageHelper: 'Many people get their G about 1-5 years after their G2.',
    },
    driverTraining: {
      fieldLabel_self: "Did you get a Driver's Education course?",
      fieldLabel_other: "Did they get a Driver's Education course?",
      helper: 'This is a course from a certified driving school (in-class + in-car lessons).',
      suggestionNo: "No, never taken a driver's education course",
      suggestionYes: 'Yes, in {{year}}',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
